// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3gkwr","content":"styles_content__2gfIW","checkbox":"styles_checkbox__2mDiY","checkboxLabel":"styles_checkboxLabel__1zZIa"};